import { ReactElement, useState } from 'react';
import { useFlags } from '@flagsmith/flagsmith/react';
import { WhatToKnow } from 'platform/components/order-confirmation/WhatToKnow';
import { Component as Check } from 'icons/icon-circle--check-circle-dark-fill.svg';
import { Button } from '../shared/button/Button';
import { EmailSignup } from './EmailSignup';
import { SocialSignup } from './SocialSignup';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import styles from './CreateAccount.module.scss';

type Props = {
  onClickLogin: () => void;
};

export function CreateAccount({ onClickLogin }: Props): ReactElement {
  const { cart } = useMenuWithCart();
  const [showEmailSignup, setShowEmailSignup] = useState(false);
  const [showSocialSignup, setShowSocialSignup] = useState(false);
  const { create_account_what_to_know: whatToKnowFlag } = useFlags(['create_account_what_to_know']);
  const showWhatToKnow = whatToKnowFlag.enabled && whatToKnowFlag.value === 'show';

  const sections = [
    {
      title: 'Get weekly reminders when it’s time to finalize your order.',
      icon: <Check height={40} width={35} />,
    },
    {
      title: 'View or shop the menu up to 4 weeks in advance.',
      icon: <Check height={40} width={35} />,
    },
    {
      title: 'Set dietary and serving preferences for future weeks.',
      icon: <Check height={40} width={35} />,
    }
  ];

  return (
    <div className={styles.button_container}>
      {showEmailSignup ? (
        <EmailSignup />
      ) : (
        <Button
          className={styles.full_width}
          data-heap-id="show_email_signup"
          text="Sign Up with Email"
          onClick={() => setShowEmailSignup(true)}
          isEnabled={!cart?.priceSummary.remainingMinimumAmount}
        />
      )}
      <div className={styles.divider}>
        <hr className={styles.full_width} />
        Or
        <hr className={styles.full_width} />
      </div>
      {showSocialSignup ? (
        <SocialSignup isLogin={false} />
      ) : (
        <Button
          className={styles.full_width}
          data-heap-id="show_social_signup"
          text="Sign Up with Social Login"
          isSecondary
          onClick={() => setShowSocialSignup(true)}
          isEnabled={!cart?.priceSummary.remainingMinimumAmount}
        />
      )}
      <hr style={{ marginTop: '35px' }} />
      <div className={styles.login_container}>
        Have an account?
        <Button
          text="Log In"
          className={styles.login_link}
          onClick={onClickLogin}
        />
      </div>
      {showWhatToKnow && (
        <div style={{
          marginTop: 'auto',
          paddingTop: '20px',
        }}
        >
          <WhatToKnow
            header="About your Account"
            sections={sections}
            isVertical
            useSmallSizing
          />
        </div>
      )}
    </div>
  );
}
